module.exports = __webpack_public_path__ + "media/images/regional-image15-5cc9976eeeead1b6a4fb1f87b683c6fc.jpg";